<template>
    <div v-bind:class="['BaseNavigationButton',className]" @click="click($event.target)">
        <i v-if="icon" :class="[icon]"></i>
        <div v-if="label" class="BaseNavigationButton__text">{{translate(label)}}</div>
    </div>
</template>

<script>
    export default {
        name: 'BaseNavigationButton',
        props: {
            //Text on the button
            label: {
                type: String
            },
            //Icon class
            icon: {
                type: String
            },
            //Additional css class name for styling
            className: {
                type: String
            }
        },
        methods: {
            click: function (e) {
                this.$emit('click', e);
            }
        }
    };
</script>

<style>
    .BaseNavigationButton {
        background-color: transparent;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 24px;
    }

    .BaseNavigationButton__text {
        font-size: 16px;
        text-transform: uppercase;
        font-weight: 500;
        padding: 0 4px;
    }

    @media (max-width: 599px) {
        .BaseNavigationButton__text {
            display: none;
        }
    }

</style>



// WEBPACK FOOTER //
// BaseNavigationButton.vue?43874fb6